(() => {
  'use strict';
  const instances = new Map();
  const WEEK = 7 * 24 * 60 * 60 * 1000;
  const KEY = 'pm-picks-dismissed-v1';
  const ACTIVE = 'pm-picks-active-ms-v1';
  const SHOWN = 'pm-picks-shown-session-v1';
  const read = (storage, key) => { try { return storage.getItem(key); } catch { return null; } };
  const write = (storage, key, value) => { try { storage.setItem(key, String(value)); } catch {} };
  function mount(root = document) {
    root.querySelectorAll('[data-pm-picks-entry]').forEach(entry => {
      if (instances.has(entry) || !window.PlaymakerPicks) return;
      let products;
      try { products = JSON.parse(entry.querySelector('[data-pm-picks-products]').textContent); } catch { return; }
      const seen = new Set();
      products = products.filter(p => !seen.has(p.productId) && seen.add(p.productId));
      if (!products.length) return;
      let timer, shown = false, disposed = false, scrolled = false;
      let activeMs = Math.max(0, Number(read(sessionStorage, ACTIVE)) || 0);
      let lastTick = performance.now(), lastInteraction = 0;
      const dismissed = () => Date.now() - (Number(read(localStorage, KEY)) || 0) < WEEK;
      const game = window.PlaymakerPicks.init({
        products, demo: false, previewOnly: !window.PlaymakerPicksBackend?.enabled,
        submit: window.PlaymakerPicksBackend?.submit,
        thresholdMinor: 13900, rewardPercent: 50, storageKey: 'pm-picks-catalog-v1',
        onStore: () => game.close(),
        onClose: () => { if (!disposed) write(localStorage, KEY, Date.now()); }
      });
      const visible = el => !!(el && el.getClientRects().length);
      const blocked = () => {
        if (/\/(cart|checkout|checkouts|account|search)(\/|$)/.test(location.pathname)) return true;
        if (document.querySelector('dialog[open]')) return true;
        if (Array.from(document.querySelectorAll('[role="dialog"],details[open],[aria-modal="true"]')).some(visible)) return true;
        const focus = document.activeElement;
        if (focus && focus.matches('input,textarea,select,[contenteditable="true"]')) return true;
        return Date.now() - lastInteraction < 5000;
      };
      const onScroll = event => {
        const offset = Math.max(window.scrollY, document.body.scrollTop, Number(event.target?.scrollTop) || 0);
        if (offset >= Math.min(240, window.innerHeight * .3)) scrolled = true;
        lastInteraction = Date.now();
      };
      const onInteraction = () => { lastInteraction = Date.now(); };
      const stop = () => {
        clearInterval(timer);
        document.removeEventListener('scroll', onScroll, true);
        document.removeEventListener('pointerdown', onInteraction, true);
        document.removeEventListener('keydown', onInteraction, true);
      };
      const tick = () => {
        const now = performance.now();
        if (!document.hidden) activeMs += Math.min(now - lastTick, 1500);
        lastTick = now;
        write(sessionStorage, ACTIVE, activeMs);
        if (shown || dismissed() || read(sessionStorage, SHOWN) || window.Shopify?.designMode) { stop(); return; }
        if (activeMs >= 20000 && scrolled && !blocked()) {
          shown = true;
          write(sessionStorage, SHOWN, 1);
          stop();
          game.open(document.activeElement);
        }
      };
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      document.addEventListener('pointerdown', onInteraction, true);
      document.addEventListener('keydown', onInteraction, true);
      timer = setInterval(tick, 500);
      instances.set(entry, { destroy: () => { disposed = true; stop(); game.destroy(); } });
    });
  }
  mount();
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((instance, entry) => {
      if (event.target.contains(entry)) { instance.destroy(); instances.delete(entry); }
    });
  });
})();

